import PropTypes from 'prop-types';
import { MediaQuery } from '@spotahome/ui-library';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  CartesianGrid
} from 'recharts';

const { isMobileScreen, isPhabletScreen, isTabletScreen } = MediaQuery;

const mobileBarSize = 15;
const desktopBarSize = 45;
const verticalBarChartHeight = 300;

const VerticalBarChart = ({ data }) => {
  const isMobileOrTablet = () =>
    isMobileScreen() || isPhabletScreen() || isTabletScreen();

  const barSize = isMobileOrTablet() ? mobileBarSize : desktopBarSize;

  return (
    <ResponsiveContainer width="100%" height={verticalBarChartHeight}>
      <BarChart data={data} barGap={4} barSize={barSize}>
        <CartesianGrid strokeDasharray="4 0" stroke="#F7F7F7" />
        <XAxis
          dataKey="label"
          tickLine={false}
          fill="#676767"
          fontSize={12}
          tickMargin={10}
        />
        <YAxis
          domain={[0, 100]}
          tickLine={false}
          fontSize={12}
          fill="#676767"
          tickFormatter={value => `${value}%`}
        />
        <Tooltip cursor={{ fill: 'transparent' }} />
        <Bar
          dataKey="available"
          fill="#0A0777"
          background={{ fill: '#F7F7F7', radius: 100 }}
          radius={[100, 100, 100, 100]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default VerticalBarChart;

VerticalBarChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      available: PropTypes.number
    })
  ).isRequired
};
